import { Box, Collapse, Flex, Text, UnstyledButton } from '@mantine/core';
import { IconArrowsMaximize } from '@tabler/icons-react';
import { useState } from 'react';
import { FONT_WEIGHTS } from 'src/UI/theme/theme';

type Props = {
  content: string;
};

export function ThinkingTile({ content }: Props) {
  const [expanded, setExpanded] = useState(false);

  return (
    <Box>
      <UnstyledButton
        onClick={() => setExpanded(!expanded)}
        py="xxxs"
        px="xxs"
        bg="orange.2"
        style={{ borderRadius: 'var(--mantine-radius-sm)' }}
      >
        <Flex align="center" gap="xxxs">
          <IconArrowsMaximize size={16} color="var(--mantine-color-gray-8)" />
          <Text size="textSm" fw={FONT_WEIGHTS.medium} c="gray.8">
            View thinking process
          </Text>
        </Flex>
      </UnstyledButton>

      <Collapse in={expanded}>
        <Text size="textSm" fw={FONT_WEIGHTS.medium} c="gray.6" mt="xs">
          {content}
        </Text>
      </Collapse>
    </Box>
  );
}
